import React, { Component } from 'react';
import withStyles from '../../decorators/withStyles';
import Header from '../Header/Header';
import styles from './NotFoundPage.css';


class NotFoundPage extends Component {

  render() {
    return (
      <div>
        <Header {...this.props} />
        <main>
          <section className="list">
            <h1>
              Place not found
            </h1>
            <hr/>
            <p>No such place exists: {this.props.params.placeID}</p>
            <hr />
            <p>Can't find what you're looking for? We can provide custom analysis.
                For more, please check out <a href="http://sealevel.climatecentral.org/maps/custom-analysis" target="_blank">our offerings</a>.</p>
          </section>
        </main>
      </div>
    );
  }

}

export default withStyles(styles)(NotFoundPage);
